import { usePropertyContext } from '../context/PropertyContext/usePropertyContext';
export const usePropertyValueTimestamp = () => usePropertyContext().timestamp;